import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
    ReservationMarketSegmentApi,
    ReserBusinessSource,
    ReserGuaranteeCodes
} from "../../Services/Service";

// Fetch All Masters
export const fetchReservationMasters = createAsyncThunk(
    "reservationMasters/fetchReservationMasters",
    async (propertyId, { rejectWithValue }) => {
        try {
            const [marketSegments, businessSources, guaranteeCodes] =
                await Promise.all([
                    ReservationMarketSegmentApi(propertyId),
                    ReserBusinessSource(propertyId),
                    ReserGuaranteeCodes(propertyId)
                ]);

            return {
                marketSegments: marketSegments || [],
                businessSources: businessSources || [],
                guaranteeCodes: guaranteeCodes || []
            };
        } catch (error) {
            return rejectWithValue(
                error?.response?.data || error.message
            );
        }
    }
);

const reservationMasterSlice = createSlice({
    name: "reservationMasters",
    initialState: {
        marketSegments: [],
        businessSources: [],
        guaranteeCodes: [],
        loading: false,
        error: null
    },
    reducers: {},

    extraReducers: (builder) => {
        builder
            .addCase(fetchReservationMasters.pending, (state) => {
                state.loading = true;
                state.error = null;
            })

            .addCase(fetchReservationMasters.fulfilled, (state, action) => {
                state.loading = false;
                state.marketSegments = action.payload.marketSegments;
                state.businessSources = action.payload.businessSources;
                state.guaranteeCodes = action.payload.guaranteeCodes;
            })

            .addCase(fetchReservationMasters.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    }
});

export default reservationMasterSlice.reducer;